import { render, staticRenderFns } from "./PointCreditTelecomConfirm.vue?vue&type=template&id=5f74e04f"
import script from "./PointCreditTelecomConfirm.vue?vue&type=script&lang=js"
export * from "./PointCreditTelecomConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports